import { normalizePhotoLabels } from "@rebuild/shared";
import { Role } from "@/enums/role";
import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "../rootReducer";

const localToken = localStorage.getItem("lassoToken");
const appState = (state: AppState) => state.app;

const user = createSelector(appState, (state) => state.user);
const token = createSelector(appState, (state) => state.token);
const lassoToken = createSelector(appState, (state) => state.lassoToken ?? localToken);

const organizationId = createSelector(appState, (state) => state.user?.organizationId);
const organizationName = createSelector(appState, (state) => state.user?.organizationName);
const loading = createSelector(appState, (state) => state.loading);
const redirectTo = createSelector(appState, (state) => state.redirectTo);

const isAdmin = createSelector(appState, (state) => state.user?.role === Role.ADMIN);
const isCreator = createSelector(appState, (state) => state.user?.role === Role.CREATOR);
const isInternal = createSelector(appState, (state) => state.user?.role === Role.INTERNAL);

/** Office names for pickers: org settings list when present, else legacy `officeList`. */
const organizationOfficeNames = createSelector(user, (u) => {
  const fromSettings = u?.extraData?.customSettings?.offices;
  if (Array.isArray(fromSettings) && fromSettings.length > 0) {
    return fromSettings.map((s) => String(s).trim()).filter(Boolean);
  }
  return (u?.extraData?.officeList ?? []).map((s) => String(s).trim()).filter(Boolean);
});

/** Org-curated photo label vocabulary; empty until an admin saves one (there is no default set). */
const organizationPhotoLabels = createSelector(user, (u) => normalizePhotoLabels(u?.extraData?.customSettings?.photoLabels));

export const appSelector = {
  user,
  token,
  loading,
  isAdmin,
  isCreator,
  isInternal,
  redirectTo,
  lassoToken,
  organizationId,
  organizationName,
  organizationOfficeNames,
  organizationPhotoLabels,
};
